import { Flex, Text } from '@chakra-ui/react';

const StatCard = ({ icon, label, value }) => (
    <Flex p="16px" bg="semantic.200" gap="8px" borderRadius="8px" flexDir="column" flex={1}>
        <Flex gap="8px" alignItems="center">
            {icon} <Text fontSize={'xs'}>{label}</Text>
        </Flex>
        <Text fontWeight={700} fontSize={'sm'}>
            {value}
        </Text>
    </Flex>
);

export default StatCard;
